import styled from 'styled-components';

export const BannerContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  gap: 50px;

  border-radius: 15px;
  overflow: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 10px;
    border-radius: 0;
    gap: 20px;
  }
`;

export const TextContainer = styled.div`
  width: 100%;
  padding: 20px;
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

export const BtnMobile = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    width: 100%;
  }
`;

export const Logo = styled.img`
  max-width: 180px;
  display: none;
  @media (max-width: 768px) {
    max-width: 180px;
    display: block;
    margin-top: 2em;
    width: 100%;
  }
`;

export const Paragraph = styled.p`
  font-size: 19px;
  color: #000;
  margin-bottom: 20px;
  text-align: justify;

  @media (max-width: 768px) {
    font-size: 18px;
    margin-bottom: 10px;
  }
`;

export const Button = styled.button`
  padding: 10px 20px;
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;

  font-size: 1em;
  color: white;
  background-color: #007bff;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }

  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 0.9em;
  }
`;

export const MobileImage = styled.img`
  flex: 1;
  max-width: 50%;
  height: 300px;
  background-size: cover;
  border-radius: 30px;
  overflow: hidden;
  display: none;

  @media (max-width: 768px) {
    margin-top: 20px;
    display: block;
    border-radius: 21px;
    width: 100%;
    height: 200px;
    max-width: 100%;
  }
`;

export const Image = styled.img`
  max-width: 100%;
  height: auto;
  display: block;

  overflow: hidden;
  border-radius: 30px;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const ParagraphFeatured = styled.p`
  font-size: 19px;
  padding: 0 3em;
  margin-bottom: 40px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 18px;
    width: 100%;
    padding: 0;
    text-align: justify;
    margin-bottom: 10px;
  }
`;
